import { getClampStyles } from "../../utils/responsive";

const CONTAINER_QUERY = { slopeUnit: "cqi" };

export function getCertificateResponsiveProperties() {
  return {
    "--certificate-gutter": getClampStyles({
      min: 8,
      max: 24,
      ...CONTAINER_QUERY,
    }),
    "--seal-size": getClampStyles({ min: 48, max: 160, ...CONTAINER_QUERY }),
    "--heading-font-size": getClampStyles({
      min: 20,
      max: 54,
      ...CONTAINER_QUERY,
    }),
    "--pre-title-font-size": getClampStyles({
      min: 7,
      max: 18,
      ...CONTAINER_QUERY,
    }),
    "--student-name-font-size": getClampStyles({
      min: 14,
      max: 42,
      ...CONTAINER_QUERY,
    }),
    "--post-title-font-size": getClampStyles({
      min: 9,
      max: 28,
      ...CONTAINER_QUERY,
    }),
    "--signature-font-size": getClampStyles({
      min: 12,
      max: 24,
      ...CONTAINER_QUERY,
    }),
    "--signature-label-font-size": getClampStyles({
      min: 8,
      max: 14,
      ...CONTAINER_QUERY,
    }),
    "--logo-max-width": getClampStyles({
      min: 80,
      max: 192,
      ...CONTAINER_QUERY,
    }),
  };
}
